import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
}

const DEFAULT_IMAGE =
  typeof window !== 'undefined'
    ? `${window.location.origin}/logo512.png`
    : 'https://yourdomain.com/og-image.jpg';

const DEFAULT_URL =
  typeof window !== 'undefined' ? window.location.href : 'https://yourdomain.com';

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = 'web developer, full stack developer, MERN stack, Next.js, portfolio, Sarfraz Ahmed, React developer',
  image = DEFAULT_IMAGE,
  url = DEFAULT_URL,
}) => {
  return (
    <Helmet>
      <title>{title} | Sarfraz Ahmed - Full Stack Developer</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;